import React, { useState } from 'react';
import Select from 'react-select';
import { Control, useController } from 'react-hook-form';
import NoSsr from '@common/noSsr';
import multiSelectStyles from './multiSelectStyle';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';
import classnames from 'classnames/bind';
import style from './multiDropDown.module.scss';

const cx = classnames.bind(style);

interface MultiDropDownProps {
  control: Control;
  name: string;
  required?: boolean;
  options: any[];
  isUseActive?: boolean;
  placeholder?: string;
  className?: string;

  onChange?(value: readonly ReactSelectOption[]): void;
}

const MultiDropDown = (props: MultiDropDownProps) => {
  const { control, name, required = false, options, isUseActive, placeholder, className } = props;
  const { field } = useController({
    name,
    control,
    rules: { required },
  });

  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const onMenuOpen = () => {
    setMenuIsOpen(true);
  };

  const onMenuClose = () => {
    setMenuIsOpen(false);
  };

  const onChangeSelect = (selectedList: readonly ReactSelectOption[]) => {
    props.onChange?.(selectedList);
    field.onChange(selectedList);
  };

  return (
    /* Next.js SSR과 react-select 호환성 관련 문제 */
    /* SSR되는 시점과 CSR 시점의 react-select ID가 달라서 에러 발생해서 NoSSR 처리 */
    <NoSsr>
      <div className={cx(['multiDropDownArea', className])}>
        <Select
          {...field}
          onMenuOpen={onMenuOpen}
          onMenuClose={onMenuClose}
          className={cx('multiDropDown', { on: menuIsOpen })}
          options={options}
          isMulti
          placeholder={placeholder}
          styles={multiSelectStyles}
          onChange={onChangeSelect}
          controlShouldRenderValue={false}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        />
      </div>
    </NoSsr>
  );
};

export default MultiDropDown;
